<template>
    <div class="js-apartment-inputs">
        <div class="integer-input">
            <label class="control-label integer-input-label">{{ apartmentSize.label }} ({{ apartment.area }}m²)</label>
            <button type="button" class="btn btn--round" v-bind:disabled="!isApartmentDecreasable || isProjectClosed"
                    v-on:click="decreaseApartment()" :title="minValue">
                <span class="glyphicon glyphicon-minus"></span>
            </button>
            <span class="integer-input-value">{{ apartment.count }} </span>
            <button type="button" class="btn btn--round" v-bind:disabled="!isApartmentIncreasable || isProjectClosed"
                    v-on:click="increaseApartment()" :title="maxValue">
                <span class="glyphicon glyphicon-plus"></span>
            </button>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        props: {
            houseId: {type: Number, required: true},
            apartmentId: {type: Number, required: true},
            apartmentSizeDict: {type: Array, required: true},
            debounceSave: {type: Function}
        },
        computed: {
            house() {
                return this.$store.findHouseById(this.houseId)
            },
            referenceHouse() {
                return this.house.referenceHouse
            },
            apartment() {
                return this.$store.getters.findApartmentById(this.houseId, this.apartmentId)
            },
            minValue() {
                return this.apartment.minCount
            },
            maxValue() {
                return this.apartment.maxCount
            },
            apartmentSize() {
                return this.apartmentSizeDict.find(size => this.apartment.apartmentSize === size.id)
            },
            isApartmentDecreasable() {
                return this.apartment.count > this.minValue &&
                    // We should not be able to remove the last apartment in the house
                    this.$store.getters.totalNumberOfApartmentsInHouse(this.houseId) > 1
            },
            isApartmentIncreasable() {
                return this.apartment.count < this.maxValue
            },
            isProjectClosed() {
                return this.$store.getters.isProjectClosed;
            }
        },

        methods: {
            ...mapActions([
                'updateHouses',
            ]),
            decreaseApartment() {
                this.$store.commit('changeApartment', {houseId: this.houseId, apartmentId: this.apartmentId, delta: -1})
                this.debounceSave()
            },
            increaseApartment() {
                this.$store.commit('changeApartment', {houseId: this.houseId, apartmentId: this.apartmentId, delta: +1})
                this.debounceSave()
            },
        }
    }
</script>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/houseApartment.vue